<template>
    <div>
        <v-card>
            <v-card-title>
                <v-text-field
                    v-model="search"
                    append-icon="search"
                    label="Search"
                    single-line
                    hide-details>
                </v-text-field>
                <v-spacer></v-spacer>
                <v-btn
                    color="primary"
                    dark
                    small
                    fab
                    @click="selectFile">
                    <v-icon>cloud_upload</v-icon>
                </v-btn>
            </v-card-title>
            <v-data-table :headers="headers" :items="userConfirmedFiles" :search="search" class="elevation-1" no-data-text="No files have been uploaded yet">
                <template v-slot:items="props">
                    <td class="text-xs-left">
                        {{ props.item.filename }}
                    </td>
                    <td class="text-xs-left">
                        {{ props.item.type ? props.item.type : '' }}
                    </td>
                    <td class="text-xs-left">
                        {{ props.item.description || '' }}
                    </td>
                    <td class="text-xs-left">
                        <v-chip>
                            {{ props.item.owner }}
                        </v-chip>
                    </td>
                    <td class="text-xs-left" v-if="props.item.upload_date">
                        {{ props.item.upload_date.toDate().toLocaleDateString('en-US', { day: 'numeric', month: 'short', year: 'numeric'}) }}
                    </td>
                    <td class="text-xs-left" v-if="props.item.last_edit_date">
                        {{ props.item.last_edit_date.toDate().toLocaleDateString('en-US', { day: 'numeric', month: 'short', year: 'numeric'}) }}
                    </td>
                    <td class="text-xs-left">
                        <v-speed-dial left direction="left" open-on-hover transition="slide-x-reverse-transition">
                            <template v-slot:activator>
                                <v-btn color="blue lighten-1" dark fab small>
                                    <v-icon>more_horiz</v-icon>
                                    <v-icon>close</v-icon>
                                </v-btn>
                            </template>
                            <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                    <v-btn fab dark small color="green" v-on="on" @click="editFile(props.item.id)">
                                        <v-icon>edit</v-icon>
                                    </v-btn>
                                </template>
                                <span>Edit</span>
                            </v-tooltip>
                            <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                    <v-btn fab dark small color="indigo" @click="downloadFile({ filename: props.item.filename, owner: props.item.owner_id })" v-on="on">
                                        <v-icon>cloud_download</v-icon>
                                    </v-btn>
                                </template>
                                <span>Download</span>
                            </v-tooltip>
                            <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                    <v-btn fab dark small color="red" @click="deleteFile({ filename: props.item.filename, owner: props.item.owner_id, fileId: props.item.id })" v-on="on">
                                        <v-icon>delete</v-icon>
                                    </v-btn>
                                </template>
                                <span>Delete</span>
                            </v-tooltip>
                        </v-speed-dial>
                    </td>
                </template>
            </v-data-table>
        </v-card>
        <v-dialog
            v-model="uploadFileDialog"
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition"
            scrollable
        >
            <v-card tile>
            <v-toolbar card dark color="primary">
                <v-btn icon dark @click="cancel">
                <v-icon>close</v-icon>
                </v-btn>
                <v-toolbar-title>Upload new file</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
                <v-stepper v-model="fileDialogStep">
                    <v-stepper-header>
                    <v-stepper-step :complete="fileDialogStep > 1" step="1">Upload & Identify</v-stepper-step>

                    <v-divider></v-divider>

                    <v-stepper-step :complete="fileDialogStep > 2" step="2">Map Columns</v-stepper-step>

                    <v-divider></v-divider>

                    <v-stepper-step step="3">Add Comments</v-stepper-step>
                    </v-stepper-header>

                    <v-stepper-items>
                        <v-stepper-content step="1">
                            <input v-show="false" type="file" @change="previewFile" id="files" ref="files" />
                            <div class="mb-5" v-if="files && files.length > 0">
                                <v-subheader>File details</v-subheader>
                                <v-divider></v-divider>
                                <v-flex xs12 sm6 md6 offset-xs1 pt-4>
                                    <v-text-field label="Filename" :value="files[0].name" disabled></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md6 offset-xs1 >
                                    <v-text-field label="Size" :value="fileSizeToString(files[0].size)" disabled></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md6 offset-xs1>
                                    <div class="v-input v-text-field v-text-field--placeholder theme--light">
                                        <div class="v-input__control">
                                            <div class="upload-progress-label v-input__slot">
                                                <div class="v-text-field__slot">
                                                    <label aria-hidden="true" class="v-label v-label--active theme--light" style="left: 0px; right: auto; position: absolute;">Upload progress</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </v-flex>
                                <v-flex xs12 sm6 md6 offset-xs1 text-xs-center white--text pb-2>
                                    <v-progress-linear v-model="uploadProgress" height="20">
                                        {{ parseInt(uploadProgress) }}%
                                    </v-progress-linear>
                                </v-flex>
                                <div v-show="(!validateFileProccessed && uploadProgress === 100)">
                                    <v-flex xs12 sm6 md6 offset-xs1>
                                        <div class="v-input v-text-field v-text-field--placeholder theme--light">
                                            <div class="v-input__control">
                                                <div class="upload-progress-label v-input__slot">
                                                    <div class="v-text-field__slot">
                                                        <label aria-hidden="true" class="v-label v-label--active theme--light" style="left: 0px; right: auto; position: absolute;">Analyzing file</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </v-flex>
                                    <v-flex xs12 sm6 md6 offset-xs1 text-xs-center white--text pb-2>
                                        <v-progress-linear indeterminate height="20">
                                        </v-progress-linear>
                                    </v-flex>
                                </div>
                                <div v-show="validateFileProccessed">
                                <v-subheader>File type</v-subheader>
                                <v-divider></v-divider>
                                <v-flex xs12 sm6 md6 offset-xs1 pt-4>
                                    <v-select 
                                        v-model="fileType"
                                        box
                                        persistent-hint
                                        :items="fileTypes"
                                        @change="resetColumnMappings"
                                        item-text="name"
                                        item-value="name"
                                        placeholder="Select file type"
                                        hint="Please identify what type of information is available in this file">
                                    </v-select>
                                </v-flex>
                                <v-subheader>Date column format</v-subheader>
                                <v-divider></v-divider>
                                <!-- <v-flex xs12 sm6 md6 offset-xs1 pt-4>
                                    <div class="v-input v-text-field v-text-field--placeholder theme--light">
                                        <div class="v-input__control">
                                            <div class="upload-progress-label v-input__slot">
                                                <div class="v-text-field__slot">
                                                    <label aria-hidden="true" class="v-label v-label--active theme--light" style="left: 0px; right: auto; position: absolute;">Date column format</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </v-flex> -->
                                <v-flex xs12 sm6 md6 offset-xs1>
                                    <v-radio-group @change="resetColumnMappings" box v-model="dateColumnMode" row persistent-hint hint="Please indicate how are dates represented in this file" mt-0>
                                        <v-radio label="Single date column" value="single" color="primary"></v-radio>
                                        <v-radio label="Start/End date columns" value="double" color="primary"></v-radio>
                                    </v-radio-group>
                                </v-flex>
                                <v-subheader>File description</v-subheader>
                                <v-divider></v-divider>
                                <v-flex xs12 sm6 md6 offset-xs1 pt-3>
                                    <v-textarea
                                        v-model="fileDescription"
                                        box
                                        no-resize
                                        persistent-hint
                                        name="fileDescription" 
                                        hint="Please provide a short description and comments about the information available in this file">
                                    </v-textarea>
                                </v-flex>
                                </div>
                            </div>
                            <v-flex xs12 sm6 md6 offset-xs1 pt-4 v-if="errorNumberOfColumns">
                                <v-alert :value="true" type="error">The selected file type and date mode requires at least {{ errorNumberOfColumns.required }} columns, but the uploaded file only has {{ errorNumberOfColumns.given }}.</v-alert>
                            </v-flex>
                            <v-flex text-xs-right>
                                <v-btn flat @click="cancel">Cancel</v-btn>
                                <v-btn color="primary" @click="fileDialogStep = 2" :disabled="validateStepOne">
                                    Next step
                                </v-btn>
                            </v-flex>
                        </v-stepper-content>
                        <v-stepper-content step="2">
                            <v-container fluid v-if="currentFileColumns">
                                <v-layout row wrap align-center>
                                    <v-flex sm3 md3 subheading font-weight-bold offset-xs1>
                                        Information
                                    </v-flex>
                                    <v-flex sm6 md6 subheading font-weight-bold>
                                        Mapped column
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap align-center pt-4 v-if="dateColumnMode">
                                    <v-flex sm3 md3 subheading offset-xs1>
                                        {{ dateColumnMode == 'single' ? 'Date' : 'Start date' }}
                                    </v-flex>
                                    <v-flex sm6 md6>
                                        <v-select
                                            :items="currentFileColumns"
                                            box
                                            item-text="name"
                                            item-value="id"
                                            v-model="columnMappings['date1']"
                                            @change="mappingChanged('date1', $event)">
                                        </v-select>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap align-center v-if="dateColumnMode == 'double'">
                                    <v-flex sm3 md3 subheading offset-xs1>
                                        End date
                                    </v-flex>
                                    <v-flex sm6 md6>
                                        <v-select
                                            :items="currentFileColumns"
                                            box
                                            item-text="name"
                                            item-value="id"
                                            v-model="columnMappings['date2']"
                                            @change="mappingChanged('date2', $event)">
                                        </v-select>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap align-center v-for="column in currentFileTypeFields" :key="column">
                                    <v-flex sm3 md3 subheading offset-xs1>
                                        {{ column }}
                                    </v-flex>
                                    <v-flex sm6 md6>
                                        <v-select
                                            :items="currentFileColumns"
                                            box
                                            item-text="name"
                                            item-value="id"
                                            v-model="columnMappings[column]"
                                            @change="mappingChanged(column, $event)">
                                        </v-select>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                            <div v-else>
                                Processing uploaded file...
                            </div>
                            <v-flex text-xs-right>
                                <v-btn flat @click="fileDialogStep = 1">Previous step</v-btn>
                                <v-btn color="primary" @click="fileDialogStep = 3" :disabled="validateStepTwo">Next step</v-btn>
                            </v-flex>
                        </v-stepper-content>

                        <v-stepper-content step="3">
                            <v-container fluid v-if="currentFileColumns">
                                <v-layout row wrap align-center pb-4>
                                    <v-flex sm3 md3 subheading font-weight-bold offset-xs1>
                                        Column
                                    </v-flex>
                                    <v-flex sm6 md6 subheading font-weight-bold>
                                        Comments
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap align-center v-for="column in currentFileColumns">
                                    <v-flex sm3 md3 subheading offset-xs1>
                                        {{ column.name }}
                                    </v-flex>
                                    <v-flex sm6 md6>
                                        <v-textarea v-model="columnComments[column.name]" no-resize persistent-hint box></v-textarea>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                            <div v-else>
                                Processing uploaded file...
                            </div>
                            <v-flex text-xs-right>
                                <v-btn flat @click="fileDialogStep = 2">Previous step</v-btn>
                                <v-btn color="primary" @click="finish">Save & Finish</v-btn>
                            </v-flex>
                        </v-stepper-content>
                    </v-stepper-items>
                </v-stepper>
            </v-card-text>
            <div style="flex: 1 1 auto;"></div>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogFileExists" width="500">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>File already exists</v-card-title>
                <v-card-text>
                    You've already uploaded a file with the same name. Delete it or rename this one before uploading it.
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" flat @click="dialogFileExists = false">Ok</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="currentFileError" width="500">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>File error</v-card-title>
                <v-card-text>
                    There was a problem processing the uploaded file, please make sure the file is in the required format.
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" flat @click="currentFileError = false">Ok</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import 'numbro'
import numbro from 'numbro';

export default {
    name: 'Files',
    data () {
        return {
            headers: [
                { text: 'Filename', value: 'filename', align: 'left' },
                { text: 'Type', value: 'type' },
                { text: 'Description', value: 'description' },
                { text: 'Uploader', value: 'owner' },
                { text: 'Upload date', value: 'upload_date' },
                { text: 'Last edit date', value: 'last_edit_date' },
                { text: '', value: '', sortable: false }
            ],
            uploadFileDialog: false,
            fileDialogStep: 1,
            files: [],
            fileType: null,
            dateColumnMode: null,
            fileDescription: null,
            dialogFileExists: false,
            search: '',
            columnMappings: {},
            columnComments: {},
            errorNumberOfColumns: null
        }
    },
    computed: {
        ...mapGetters([
            'userFiles',
            'uploadProgress',
            'currentFileDocId',
            'userCurrentClient'
        ]),
        fileTypes: function () {
            if (this.userCurrentClient && this.userCurrentClient.fileTypes) {
                return this.userCurrentClient.fileTypes.filter(function (element) {
                    return 'fields' in element
                })
            }
        },
        currentFileTypeFields: function () {
            if (this.fileType && this.fileTypes && this.fileTypes.length > 0) {
                for (var i = 0; i < this.fileTypes.length; i++) {
                    if( this.fileTypes[i].name == this.fileType && 'fields' in this.fileTypes[i]) {
                        return this.fileTypes[i].fields
                    }
                }
            } else {
                return null
            }
        },
        /* unmappedFileTypeFields: function () {
            var unmapped = []
            if (this.currentFileTypeFields && this.columnMappings) {
                for (var i = 0; i < this.currentFileTypeFields.length; i++) {
                    if (!(this.currentFileTypeFields[i] in this.columnMappings)) {
                        unmapped.push(this.currentFileTypeFields[i])
                    }
                }
            }
            return unmapped
        }, */
        validateFileProccessed: function () {
            if (this.currentFileColumns) {
                return true
            } else {
                return false
            }
        },
        validateStepOne: function () {
            if (this.currentFileTypeFields && this.currentFileColumns && this.dateColumnMode) {
                var extraDateColumns = 1
                if (this.dateColumnMode == 'double') {
                    extraDateColumns = 2
                }
                if ((this.currentFileTypeFields.length + extraDateColumns) > this.currentFileColumns.length) {
                    this.errorNumberOfColumns = {
                        required: this.currentFileTypeFields.length + extraDateColumns,
                        given: this.currentFileColumns.length
                    }
                    return true
                } else {
                    this.errorNumberOfColumns = null
                }
            }
            return !(this.currentFileTypeFields && this.currentFileColumns && this.fileDescription && this.dateColumnMode)
        },
        validateStepTwo: function () {
            if (this.columnMappings && this.currentFileTypeFields && this.dateColumnMode) {
                var extraDateColumns = 1
                if (this.dateColumnMode == 'double') {
                    extraDateColumns = 2
                }
                return !(Object.keys(this.columnMappings).length == (this.currentFileTypeFields.length + extraDateColumns))
            } else {
                return true
            }
            
        },
        userConfirmedFiles: function () {
            return this.userFiles.filter(function(item) {
                return 'description' in item && 'dateColumnMode' in item && 'type' in item
            })
        },
        currentFileColumns: function () {
            if (this.currentFileDocId && this.userFiles) {
                var files = this.userFiles.filter(item => {
                    return item.id == this.currentFileDocId
                })
                if (files.length > 0 && 'columns' in files[0]) {
                    return files[0]['columns']
                }
            }
        },
        currentFileError: {
            get: function () {
                if (this.currentFileDocId && this.userFiles) {
                    var files = this.userFiles.filter(item => {
                        return item.id == this.currentFileDocId
                    })
                    if (files.length > 0 && 'fileError' in files[0]) {
                        return true
                    } else {
                        return false
                    }
                } else {
                    return false
                }
            },
            set: function (newValue) {
                if (newValue == false) {
                    // TODO: Make the popup dissapear faster
                    this.cancel()
                }
            }
        } 
    },
    methods: {
        ...mapActions([
            'uploadFile',
            'downloadFile',
            'deleteFile',
            'deleteUploadedFile',
            'cancelUpload',
            'resetUploadProgress',
            'confirmFile'
        ]),
        resetColumnMappings: function () {
            this.columnMappings = {}
        },
        mappingChanged: function (field, fileColumn) {
            // Remove every other column mapping to the same field just mapped
            var columnMappingsKeys = Object.keys(this.columnMappings)
            for (var i = 0; i < columnMappingsKeys.length; i++) {
                if (columnMappingsKeys[i] != field && this.columnMappings[columnMappingsKeys[i]] == fileColumn) {
                    this.$delete(this.columnMappings, columnMappingsKeys[i])
                }
            }
        },
        fileSizeToString: function (size) {
            return numbro(size).format({
                output: "byte",
                base: "binary",
                mantissa: 1
            })
        },
        checkIfFileExists: function (filename) {
            for (var i = 0; i < this.userFiles.length; i++) {
                if (this.userFiles[i].filename == filename) {
                    return true
                }
            }  
            return false
        },
        editFile: function (id) {
            console.log('Editing: ', id)
            var file = this.userConfirmedFiles.filter(function (file) {
                if (file.id == id) {
                    return true
                }
            })[0]
            this.files.push({
                name: file.filename
                // TODO Add file size
            })
            this.$store.commit('set_current_file_doc_id', file.id)
            this.columns = file.columns
            this.columnComments = Object.assign({}, file.columnComments)
            this.columnMappings = Object.assign({}, file.columnMappings)
            this.dateColumnMode = file.dateColumnMode
            this.fileType = file.type
            this.fileDescription = file.description
            this.uploadFileDialog = true
        },
        previewFile: function () {
            console.log('this.$refs.files: ', this.$refs.files)
            console.log('this.$refs.files.files: ', this.$refs.files.files)
            this.files = this.$refs.files.files
            if (this.files && this.files.length > 0 && this.checkIfFileExists(this.files[0].name)) {
                // File exists
                this.dialogFileExists = true
                this.$refs.files.value = null
                this.files = []
            } else if (this.files && this.files.length > 0) {
                // File does not exist
                this.uploadFileDialog = true
                this.uploadFile({
                    file: this.files[0]
                })
            }
        },
        selectFile: function () {
            this.$refs.files.click()
        },
        cancel: function () {
            if (this.uploadProgress != 100) {
                this.cancelUpload()
            } else {
                this.deleteUploadedFile({
                    file: this.files[0]
                })
            }
            this.clear()
        },
        finish: function () {
            this.confirmFile({
                file: this.files[0],
                description: this.fileDescription,
                dateColumnMode: this.dateColumnMode,
                type: this.fileType,
                columnMappings: this.columnMappings,
                columnComments: this.columnComments
            })
            this.clear()
        },
        clear: function () {
            this.uploadFileDialog = false
            this.$refs.files.value = null
            this.files = []
            this.fileDialogStep = 1
            this.fileType = null
            this.dateColumnMode = null
            this.fileDescription = null
            this.errorNumberOfColumns = null
            this.columnMappings = {}
            this.columnComments = {}
            this.resetUploadProgress()
        }
    }
    /* ,
    watch: {
        columnMappings: {
            handler: function (val) {
                console.log(val)
            },
            deep: true
        }
    } */
}
</script>
<style>
    .upload-progress-label:before {
    border-style: none !important;
    }
</style>
